import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

interface ButtonWithIconProps {
  onClickHandler: () => void;
  iconElement: IconProp;
  buttonText: string | React.ReactNode;
}

export const ButtonWithIcon: React.FC<ButtonWithIconProps> = ({
  onClickHandler,
  iconElement,
  buttonText,
}) => {
  return (
    <button
      onClick={onClickHandler}
      className='text-reskin-primary-blue hover:text-reskin-primary-blue-hover transition-colors flex items-center gap-2 flex-shrink-0 leading-5'
      aria-label={`${buttonText}-new`}
    >
      <FontAwesomeIcon icon={iconElement} size='sm' />
      <span className='text-base font-inter'>{buttonText}</span>
    </button>
  );
};
